/**
 * 施設カード：複数画像があるときホバー中に順送り表示。
 * ホバー非対応端末では先頭画像のまま。
 */
(() => {
  if (window.MiyabiFoodStayGallery) return;

  const INTERVAL_MS = 1400;

  function prefersHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function bindGallery(gallery) {
    const images = Array.from(gallery.querySelectorAll('.food-stay-card__banner-image'));
    if (images.length < 2) return;

    let index = 0;
    let timer = null;
    const hoverRoot = gallery.closest('.food-stay-card__banner-link') || gallery;

    const show = (next) => {
      index = ((next % images.length) + images.length) % images.length;
      images.forEach((img, i) => {
        const active = i === index;
        img.classList.toggle('is-active', active);
        if (active) img.removeAttribute('aria-hidden');
        else img.setAttribute('aria-hidden', 'true');
      });
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      show(0);
    };

    const start = () => {
      if (!prefersHover() || timer) return;
      timer = window.setInterval(() => {
        show(index + 1);
      }, INTERVAL_MS);
    };

    hoverRoot.addEventListener('mouseenter', start);
    hoverRoot.addEventListener('mouseleave', stop);
    hoverRoot.addEventListener('focusin', start);
    hoverRoot.addEventListener('focusout', (event) => {
      if (!hoverRoot.contains(event.relatedTarget)) stop();
    });
  }

  function init() {
    document.querySelectorAll('[data-food-stay-gallery]').forEach(bindGallery);
  }

  window.MiyabiFoodStayGallery = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
